interface routerItem {
  name: string // Path Name
  path: string // Router Link
  href?: string // External Link
  target?: '_blank' // External Link opens in a new window
  clickEvent?: boolean // Click event to trigger a function
  component?: unknown // Component which should be rendered
}
export interface utilityItem extends routerItem {
  props?: { icon: string } // Utility Menu icons
  meta?: { authorizedUsers?: number[] } // User Roles with Access
}

interface navItem extends routerItem {
  meta?: {
    title?: string // Page Title (when Page Header is in Page Layout. Remove if moved to individual pages.)
    breadCrumb?: string // Page Breadcrumb
    requiresAuth?: boolean // Entra Authentication
    authorizedUsers?: number[] // User Roles with Access
    childrenInNav?: boolean // Hides children from nav
    navGroup?: boolean // Style item as nav Group
  }
}

interface navLevel extends navItem {
  children?: navItem // Grandchild - Level Two
}

export interface navList extends navItem {
  children?: navLevel // Child - Level One
}

export interface userInfo {
  userDisplayName: string
  prevLastLoginDt: Date | string | null
  userRoles?: number[]
  userDisplayRoles?: string | string[]
  prevLoginAttempts?: number | null
  customCaption?: string
  customCaptionTitle?: string
}

export interface breadcrumb {
  disabled?: boolean
  exact?: boolean
  href?: string
  link?: boolean
  text: string | number
  to?: string | object
}

export interface links {
  text: string
  url: string
  icon: string
  target: string
}

// BUG: Filtered nav only works for top level filtering, should also filter children
export function filteredMenu(
  list: Array<utilityItem | navList>,
  userInfo: userInfo
): Array<utilityItem | navList> {
  const filteredNav = list.filter((x) => {
    const authUsers = x.meta?.authorizedUsers
    if (authUsers) {
      return authUsers.some((r) => {
        return userInfo.userRoles?.includes(r)
      })
    }
    return true
  })
  return filteredNav
}
